// Static thermal-printer hardware config. The club name is intentionally NOT
// here — callers pass it in from useClientConfig().branding.clubName so the
// receipt header is driven by per-tenant settings.
export const PRINTER_CONFIG = {
  DEFAULT_PRINTER_NAME: 'EPSON TM-T88VI',
  PRINTER_TYPE: 'epson' as 'epson' | 'star',
  PRINTER_WIDTH: 42,
  RECEIPT_WIDTH_MM: 80,

  FONT_FAMILY: 'Courier New',
  FONT_SIZE: '12px',

  PRINT_TIMEOUT_MS: 1000,
  POPUP_TIMEOUT_MS: 500,

  CASH_DRAWER_PIN: '2pin' as '2pin' | '5pin',

  STYLES: {
    header: {
      fontSize: '14px',
      fontWeight: 'bold',
      marginBottom: '10px'
    },
    item: {
      fontSize: '11px',
      margin: '2px 0'
    },
    total: {
      fontSize: '14px',
      fontWeight: 'bold',
      marginTop: '10px'
    },
    footer: {
      fontSize: '10px',
      color: '#666',
      marginTop: '20px'
    }
  }
};

export interface PrinterConfig {
  printerName: string;
  clubName: string;
  printerType: 'epson' | 'star';
  printerWidth: number;
  cashDrawerPin: '2pin' | '5pin';
  RECEIPT_WIDTH_MM: number;
  FONT_FAMILY: string;
  FONT_SIZE: string;
  PRINT_TIMEOUT_MS: number;
  POPUP_TIMEOUT_MS: number;
  STYLES: typeof PRINTER_CONFIG.STYLES;
}

export const getPrinterConfig = (clubName: string): PrinterConfig => ({
  printerName: PRINTER_CONFIG.DEFAULT_PRINTER_NAME,
  clubName,
  printerType: PRINTER_CONFIG.PRINTER_TYPE,
  printerWidth: PRINTER_CONFIG.PRINTER_WIDTH,
  cashDrawerPin: PRINTER_CONFIG.CASH_DRAWER_PIN,
  RECEIPT_WIDTH_MM: PRINTER_CONFIG.RECEIPT_WIDTH_MM,
  FONT_FAMILY: PRINTER_CONFIG.FONT_FAMILY,
  FONT_SIZE: PRINTER_CONFIG.FONT_SIZE,
  PRINT_TIMEOUT_MS: PRINTER_CONFIG.PRINT_TIMEOUT_MS,
  POPUP_TIMEOUT_MS: PRINTER_CONFIG.POPUP_TIMEOUT_MS,
  STYLES: PRINTER_CONFIG.STYLES,
});
